import React,{ Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import FieldGroup from "../../../../components/FieldGroup";
import SelectWrap from "../../../../components/SelectWrap";
import { handleFieldChange } from '../../../../Utils';

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            zone: '',
            ssId: ''
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(e) {
        e.preventDefault();

        this.props.onSubmit(this.state);
    }

    render() {
        return (
            <form onSubmit={this.handleFormSubmit}>
                <Row>
                    <Col lg={6}>
                        <SelectWrap
                            values={[ 'H', 'L' ]}
                            label="Zone:"
                            name="zone"
                            onChange={this.handleFieldChange}
                            value={this.state.zone}
                        />
                    </Col>
                    <Col lg={6}>
                        <FieldGroup
                            type="number"
                            name="ssId"
                            label="SS Id:"
                            onChange={this.handleFieldChange}
                            value={this.state.ssId}
                            required
                        />
                    </Col>
                </Row>

                <Button type="submit" bsStyle="success" className="m-b-15" >Save</Button>
                <Button type="button" bsStyle="success" className="m-b-15" onClick={this.props.onSync}>Sync</Button>
            </form>
        );
    }
}

export default Filters;


// WEBPACK FOOTER //
// ./src/scenes/SSRotator/components/Form/index.js